import {useCurrentUser} from 'modules/authentication/provider/hook';
import {useLazyPromise} from 'utils/async';
import {apiUpdateLanguage, AvailableLanguage} from './api';

export const useLanguageHook = () => {
	const {user, mutate} = useCurrentUser();
	const changePreferredlanguage =
		user === undefined
			? undefined
			: useLazyPromise(async (data?: AvailableLanguage) => {
					// 	console.log('preferred manguage: ', data);
					await apiUpdateLanguage(data);
					// ❌ TODO: check if error !!!
					// force user update
					mutate();
			  });
	return {
		/**
		 * Will be undefined if no logged in user.
		 */
		changePreferredlanguage
	};
};
